export default __webpack_public_path__ + "static/media/ImpactoZ_Ticket.2cbffd34.jpg";